/*
 * Copyright (c) Schrocken Inc.
 * Author: Ravi Teja
 * File Description: Reducer file for authentication
 */

import {
  USER_LOGIN,
  ADMIN_SIGNUP,
  INVITED_USER,
  PASSWORD_CRITERIA,
} from '../actions/types';

const initialState = {
  login: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case USER_LOGIN:
      return {
        ...state,
        login: action.payload,
      };
    case ADMIN_SIGNUP:
      return {
        ...state,
        adminSignUp: action.payload,
      };
    case PASSWORD_CRITERIA:
      return {
        ...state,
        password: action.payload,
      };
    case INVITED_USER:
      return {
        ...state,
        invitedUserData: action.payload,
      };
    default:
      return state;
  }
}
